<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-case code="attestation-veracite" v-model="sasInspection3.attestationVeracite" :live="liveSasInspection3(12642)"> </opq-case>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [FormSimple],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasInspection3() {
      return this.sas.sasInspection3
    }
  },

  methods: {
    liveSasInspection3(cle) {
      return { endpoint: "/sas-inspection-3/", cle: cle, fileId: this.sasInspection3.id }
    }
  }
}
</script>

<style>
</style>